import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  UpdateBrand,
} from "../../../redux/services/BrandService/brand.Services";
import { ActiveCategoryList } from "../../../redux/services/categoriesService/categories.Services";
// import { ActiveSubCategoryList } from "../../../redux/services/subCategoriesService/subCategories.Services";
import {
  successToast,
  errorToast,
} from "../../../Utils/toast";

import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";

function EditBrand({ data, onSuccess }) {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState("");
  const [isLoading, setIsLoading] = useState(false);
const [formData, setFormData] = useState({
  name: "",
  status: true,
  logo: null,
});

  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        status: data.status === 1 || data.status === true,
           logo: null,
      });
        if (data.logo) {
      setPreview(
        `${process.env.REACT_APP_IMAGE_URL}/brand/${data.logo}`
      );
    }
    }
  }, [data]);

const handleChange = (e) => {
  const { name, value, files } = e.target;

  if (name === "logo") {
    const file = files[0];

    setFormData((prev) => ({
      ...prev,
      logo: file,
    }));

    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: name === "status" ? value === "Active" : value,
    }));
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const payload = new FormData();

    payload.append("id", data.id);
    payload.append("name", formData.name);
    payload.append("status", formData.status ? 1 : 0);

    if (formData.logo) {
      payload.append("logo", formData.logo);
    }
   const res = await UpdateBrand(payload);
      successToast( res?.message );
       dispatch(refreshProductList());
    dispatch(closeProductModal());
    } catch (err) {
      console.log(err);
        errorToast(
      err?.response?.data?.message || "Error updating category"
    );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">

      <form
        onSubmit={handleSubmit}
        className="row "
      >

        <div className="col-md-12">
          <label>Brand Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="form-control"
            placeholder="Enter Btand name"
          />
        </div>
        <div className="col-md-12 mb-3">
  <label>Brand Logo</label>

  <input
    type="file"
    name="logo"
    className="form-control"
    onChange={handleChange}
    accept="image/*"
  />
</div>
<div className="text-center mb-3">
  <img
    src={preview || "/placeholder-image.png"}
    alt="Brand Preview"
    width="120"
    height="120"
    className="img-thumbnail"
    style={{ objectFit: "cover" }}
  />
</div>
        <div className="col-md-12">
          <label>Status</label>
          <select
            name="status"
            value={
              formData.status
                ? "Active"
                : "Inactive"
            }
            onChange={handleChange}
            className="form-control"
          >
            <option value="Active">
              Active
            </option>
            <option value="Inactive">
              Inactive
            </option>
          </select>
        </div>
        <div className="col-md-12 text-end">
          <button
            type="submit"
            disabled={isLoading}
            className="add-btn"
          >
            {isLoading
              ? "Updating..."
              : "Update Brand"}
          </button>
        </div>

      </form>

    </div>
  );
}

export default EditBrand;